import { setTranslations as _setTranslations, getTranslations, t } from './utils/l10n';

let _theme = 'light';
let _customTheme = {};

export function setTranslations(translations) {
  _setTranslations(translations);
}

export { getTranslations, t };

export function setTheme(theme) {
  _theme = theme;
}

export function getTheme() {
  return _theme;
}

export function setCustomTheme(customTheme) {
  _customTheme = { ..._customTheme, ...customTheme };
}

export function getCustomTheme() {
  return _customTheme;
}

// ── Input Fields Dialog Config ───────────────────────────────────────
const INPUT_FIELDS_CONFIG_KEY = '__labellife_input_fields_config__';
if (typeof window !== 'undefined' && !window[INPUT_FIELDS_CONFIG_KEY]) {
  window[INPUT_FIELDS_CONFIG_KEY] = {};
}

export function setInputFieldsConfig(config) {
  if (typeof window !== 'undefined') {
    window[INPUT_FIELDS_CONFIG_KEY] = { ...window[INPUT_FIELDS_CONFIG_KEY], ...config };
  }
}

export function getInputFieldsConfig() {
  return (typeof window !== 'undefined' && window[INPUT_FIELDS_CONFIG_KEY]) || {};
}
